import type * as React from 'react';

import { cn } from '@/lib/utils';

interface PanelProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'title'> {
  title?: React.ReactNode;
  /** À droite du titre : badge, action. */
  aside?: React.ReactNode;
}

/**
 * Bloc encadré dans une carte (`attempt` des maquettes : une tentative de
 * requête) : filet `border`, rayon lg, padding 16px, contenu espacé de 16px.
 */
function Panel({ title, aside, className, children, ...props }: PanelProps): React.JSX.Element {
  return (
    <div className={cn('grid gap-4 rounded-lg border border-border p-4', className)} {...props}>
      {title !== undefined || aside !== undefined ? (
        <div className="flex items-center justify-between gap-3">
          {title !== undefined ? <h3 className="m-0 text-heading">{title}</h3> : <span />}
          {aside}
        </div>
      ) : null}
      {children}
    </div>
  );
}

export { Panel };
